import supabase from '../utils/supabaseClient';

// Data-access layer for the `familia` table.
// Pages import these functions instead of calling `supabase.from('familia')`
// directly, so the table name, column selection and filters live in one place.
// Each function resolves to plain data on success and throws the Supabase error
// on failure — callers wrap in try/catch to apply their own fallback.

/**
 * Familias joined with their thumbnail rows, ordered by `number` ascending.
 * @returns {Promise<Array>}
 */
export async function getFamiliasWithThumbnails() {
  const { data, error } = await supabase
    .from('familia')
    .select(`
      id,
      nombre,
      number,
      familia_thumbnail!left(url)
    `)
    .order('number', { ascending: true });

  if (error) throw error;
  return data || [];
}

/**
 * Familias restricted to a set of ids, ordered by `number` ascending.
 * @param {Array<string|number>} ids
 * @returns {Promise<Array>}
 */
export async function getFamiliasByIds(ids) {
  const { data, error } = await supabase
    .from('familia')
    .select('id, nombre, number')
    .in('id', ids)
    .order('number', { ascending: true });

  if (error) throw error;
  return data || [];
}

/**
 * Every familia row — used to build id → familia lookup maps.
 * @returns {Promise<Array>}
 */
export async function getAllFamilias() {
  const { data, error } = await supabase.from('familia').select('*');

  if (error) throw error;
  return data || [];
}
